import styled from 'styled-components';

export const GridContainer = styled.div<{
  $columnSize: number;
}>`
  display: grid;
  grid-template-columns: ${({ $columnSize }) => `50px 75px repeat(${$columnSize}, auto) 1fr`};
  grid-template-rows: 40px auto;
  text-overflow: ellipsis;
`;

export const GridCell = styled.div`
  place-self: stretch;
  display: flex;
  justify-content: start;
  align-items: center;
`;

export const GridHeaderCell = styled(GridCell)`
  position: sticky;
  top: 0;
  color: rgb(110, 119, 122);
  white-space: nowrap;
  z-index: 3;
`;
